import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  subscribers: [],
}

export const getSubscribers = createAsyncThunk('subscriber/getSubscribers', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId } = state.auth

  let subURL;
  if (authId === 100) {
    subURL = 'api/gatesubscribers/'
  } else if (authId === 1) {
    subURL = 'api/gatesubscribers/id/' + subscriberId;
  }
  if (!subURL) return []

  return await fetch( apiURL + subURL, {
    method: 'get',
    headers: { 'Accept': 'application/json', 'Authorization': webToken },
    credentials: 'include'
  })
  .then(response => response.json())
  // Guard the array: a 200 whose body lacks `rows` (error-shaped JSON / shape change) must not
  // overwrite `subscribers: []` with undefined — every consumer .map()s this. (getSubscribers now
  // runs on every super login via App.getInitialData, so keep the store's invariant airtight.)
  .then(data => (data && Array.isArray(data.rows)) ? data.rows : [])
  .catch(error => {
      console.error('Error:', error)
      return []
  })
});

const subscriberSlice = createSlice({
  name: 'subscriber',
  initialState,
  reducers: {
    setSubscriberState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubscribers.fulfilled, (state, action) => {
        state.subscribers = action.payload
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setSubscriberState } = subscriberSlice.actions
export default subscriberSlice.reducer
